import { CloseOutlined } from '@mui/icons-material';
import CalendarIcon from '@mui/icons-material/CalendarTodayOutlined';
import {
  Box,
  IconButton,
  InputAdornment,
  StandardTextFieldProps,
  TextField,
  Typography
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useState } from 'react';

interface DateFieldProps extends StandardTextFieldProps {
  topLabel?: string;
  onChange: (e: any) => void;
  required?: boolean;
  size?: 'small' | 'medium';
  type?: string;
  maxLength?: number;
  disabled?: boolean;
  disablePast?: boolean;
  disableFuture?: boolean;
  maxDate?: any;
  minDate?: any;
  shrinkLabel?: boolean;
  endIcon?: any;
  endIconOnClick?: () => void;
  clearIcon?: any;
  clearIconOnClick?: () => void;
}

function DateField(props: DateFieldProps) {
  const {
    label,
    value,
    error,
    placeholder,
    disabled,
    disablePast,
    maxDate,
    minDate,
    onChange,
    shrinkLabel,
    sx = {},
    endIcon = <CalendarIcon sx={{ height: '1.9rem', width: '1.9rem' }} />,
    endIconOnClick,
    size = 'medium',
    clearIcon,
    clearIconOnClick,
    helperText,
    disableFuture,
    topLabel,
    onKeyDown,
    required
  } = props;
  const [openPicker, setOpenPicker] = useState(false);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        // orientation="landscape"
        label={label}
        value={value ?? null}
        views={['year', 'month', 'day']}
        openTo="year"
        disabled={disabled}
        showToolbar={false}
        disablePast={disablePast}
        maxDate={maxDate}
        minDate={minDate}
        onChange={onChange}
        inputFormat="dd-MM-yyyy"
        open={openPicker}
        disableFuture={disableFuture}
        onClose={() => {
          if (openPicker) setOpenPicker(false);
        }}
        onOpen={() => {
          if (!disabled) setOpenPicker(true);
        }}
        renderInput={(params) => (
          <Box>
            {topLabel && (
              <Typography variant="body1" sx={{ fontWeight: '500', mb: '1rem' }}>
                {topLabel}
                {required && '*'}
              </Typography>
            )}
            <TextField
              {...params}
              sx={sx}
              onKeyDown={onKeyDown}
              error={error}
              helperText={helperText}
              size={size}
              onClick={() => {
                if (!disabled) setOpenPicker(true);
              }}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
                style: {
                  fontFamily: 'Source Sans 3',
                  fontSize: '1.4rem'
                }
              }}
              placeholder={placeholder}
              InputLabelProps={{
                shrink: shrinkLabel,
                style: {
                  fontFamily: 'Source Sans 3'
                  // fontSize: '1.32rem'
                  // fontSize: "1.32rem",
                }
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {clearIcon && (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={clearIconOnClick}
                          disabled={disabled}
                          sx={{ height: '2.55rem', width: '2.55rem' }}>
                          <CloseOutlined sx={{ height: '1.9rem', width: '1.9rem' }} />
                        </IconButton>
                      </InputAdornment>
                    )}
                    {endIcon && (
                      <InputAdornment position="end">
                        <IconButton
                          disabled={disabled}
                          disableRipple={endIconOnClick ? true : false}
                          sx={{ height: '2.55rem', width: '2.55rem' }}
                          onClick={(e) => {
                            if (endIconOnClick) {
                              e.stopPropagation();
                              endIconOnClick();
                            }
                          }}>
                          {endIcon}
                        </IconButton>
                      </InputAdornment>
                    )}
                  </Box>
                )
              }}
            />
          </Box>
        )}
      />
    </LocalizationProvider>
  );
}

export default DateField;
